// extracted by mini-css-extract-plugin
export var tkMyriadProSemiCondensed = "Wrapper--tk-myriad-pro-semi-condensed--Amft9";
export var wrapper__container = "Wrapper--wrapper__container--IiFvw";
export var wrapper__content = "Wrapper--wrapper__content--8eCpc";